export default [
  {
    _name: 'CSidebarNav',
    _children: [
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Attendance',
      //   to: '/attendance',
      //   icon: 'cil-people'
      // },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Attendance',
        route: '/attendance',
        icon: 'cil-people',
        items: [
          {
            name: 'Scanner',
            to: '/attendance',
          },
          {
            name: 'Records',
            to: '/records',
          },
        ]
      },
      // {
      //   _name: 'CSidebarNavDropdown',
      //   name: 'Export',
      //   route: '/export',
      //   icon: 'cil-chevron-bottom',
      //   items: [
      //     {
      //       name: 'Attendance',
      //       to: '/export-attendance',
      //     },
      //   ]
      // },
      // {
      //   _name: 'CSidebarNavDropdown',
      //   name: 'Import',
      //   route: '/import-settings',
      //   icon: 'cil-chevron-top',
      //   items: [
      //     {
      //       name: 'Settings',
      //       to: '/import-settings',
      //     },
      //   ]
      // },
    ]
  }
]